export class UserEntity {

    public id: number = 0;//this is long because of teacher national id or tsc number
    public username: string = "";
    public password: string = "";
    public groupId: number = 0; //exam admin=1,accounts clerk=2,bursar=3,teacher=4,SMS admin=5 

}